var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavCatalog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#898e9a;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -7.358)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73.446,69.914H72.14l-1.223,1.211h3.134a.674.674,0,0,0,.606-.606V67.375l-1.211,1.216Z",
    transform: "translate(-55.73 -49.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.321,9.359H5.58a.584.584,0,0,0-.58.6v11.5a.605.605,0,0,0,.606.606h7.872l5.45-5.45V9.963a.6.6,0,0,0-.606-.6Zm-3.037,1.187a.625.625,0,1,1-.625.625A.625.625,0,0,1,15.284,10.546Zm-6.646,0a.625.625,0,1,1-.625.625A.625.625,0,0,1,8.639,10.546Zm9.077,6.078H14.083a.605.605,0,0,0-.606.606v3.633H6.211V12.992h11.5Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCatalog);
export default __webpack_public_path__ + "static/media/nav-catalog.0fcf49b0220e924261947140ab2c70ca.svg";
export { ForwardRef as ReactComponent };